<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'paymentApplyEdit',
    components: {
      baseEdit,
    },
  };
</script>
